import { Flex } from '@lokalise/louis';

import styled from '@app/styled';
import { mediaQuery, spacing } from '@app/theme';

export const Footer = styled(Flex)`
    padding: ${spacing(5, 0)};
    flex-direction: column;
    align-items: stretch;
    ${mediaQuery.min('sm')} {
        align-items: flex-start;
        flex-direction: row;
    }
`;
